export default "__VITE_ASSET__oKmGicpK__"